import _ from "lodash";
import React, { PureComponent } from "react";
import classes from "./AddPostDetails.scss";
import ScreenPanel from "Post/routes/CreatePost/components/ScreenPanel";
import I18nHOC from "UIComponents/I18nHOC";
import MediaModal from "UIComponents/MediaModal";
import TextAreaInput from "UIComponents/TextAreaInput";
import MediaPlaceholder from "UIComponents/MediaPlaceholder";
import Note from "UIComponents/Note";
import DateSelector from "UIComponents/DateSelector";
import TimeSelector from "UIComponents/TimeSelector";
import { Button } from "@toddle-edu/ds-web";
import { PublishOutlined } from "@toddle-edu/ds-icons";
import moment from "moment";
import { formatDate } from "Utils";
import { compose } from "lib/apolloClient";
import { useTranslation } from "react-i18next";
import CreatePost from "ProcessJournal/components/CreatePost/CreatePost";
import ProjectElementTag from "ProcessJournal/components/CreatePost/components/ProjectElementTag";
import { PROJECT_TEMPLATE_FIELD_OBJECTS } from "ProcessJournal/modules/Module";

const FooterComponent = props => {
  const {
    addButtonLabel,
    onClickClose,
    onClickSave,
    showPublishIcon = false,
  } = props;
  const { t } = useTranslation(["journal", "common"]);

  return (
    <div className={classes.footerButtonContainer}>
      <Button variant={"outlined"} onClick={onClickClose}>
        {t("common:discard")}
      </Button>

      <Button
        variant={"progressive"}
        onClick={onClickSave}
        icon={showPublishIcon ? <PublishOutlined /> : null}
      >
        {t(addButtonLabel)}
      </Button>
    </div>
  );
};

const noteTextAreaStyles = {
  borderWidth: 0,
  padding: 0,
  overflowY: "hidden",
};

class AddPostDetails extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      tagModalType: null,
      showMediaModal: false,
      currentElementTag: null,
      showTagModal: false,
    };
  }

  toggleMediaModal = value => {
    this.setState({
      showMediaModal: value,
    });
  };

  goToStep = (step, projectElement) => {
    this.setState({
      showTagModal: true,
      tagModalType: step,
      currentElementTag: projectElement,
    });
  };

  onCloseTagModal = () => {
    this.setState({
      showTagModal: false,
      tagModalType: null,
    });
  };

  updateNote = params => {
    const { screenPanelProps: { updatePost, postDetails } = {} } = this.props;
    const attachment = _.get(postDetails, "attachments[0]", {});

    updatePost({ attachments: [{ ...attachment, ...params }] });
  };

  render() {
    const { t, screenPanelProps = {} } = this.props;
    const {
      tagModalType,
      showMediaModal,
      currentElementTag,
      showTagModal,
    } = this.state;

    const {
      mode,
      updatePost,
      onCloseClick,
      onClickSave,
      postDetails = {},
      mediaCreationOptions,
      parentType,
    } = screenPanelProps;

    const { title, attachments = [], elementPYP = [], createdAt } = postDetails;

    const currentDate = formatDate({ date: createdAt, format: "YYYY-MM-DD" });

    const currentTime = moment(createdAt).format("HH:mm:ss");

    const onDateAndTimeUpdate = ({ newDate, newTime }) => {
      const updatedDate = moment(
        `${newDate ? newDate : currentDate} ${newTime ? newTime : currentTime}`
      ).toISOString();

      updatePost({
        createdAt: updatedDate,
      });
    };
    return (
      <>
        <ScreenPanel
          {...screenPanelProps}
          footerComponent={
            <FooterComponent
              mode={mode}
              onClickSave={onClickSave}
              {...mediaCreationOptions}
              onClickClose={onCloseClick}
            />
          }
        >
          <div className={classes.container}>
            <div className={classes.basicDetailContainer}>
              <TextAreaInput
                name={"title"}
                value={title}
                minRows={5}
                placeholder={t("journal:edit_post_placeholder_textarea")}
                updateInputField={updatePost}
              />
              <div className={classes.mediaPlaceHolderContainer}>
                {attachments[0]?.type == "NOTE" ? (
                  <Note
                    value={attachments[0].title}
                    updateNote={this.updateNote}
                    placeholder={t("common:text_placeholder")}
                    noteName={"title"}
                    noteTextAreaStyles={noteTextAreaStyles}
                  />
                ) : (
                  <MediaPlaceholder
                    attachments={attachments}
                    onClickMedia={() => this.toggleMediaModal(true)}
                    showVideoPlayer={true}
                    imageMaxWidth={460}
                  />
                )}
              </div>
            </div>
            <div className={classes.tagOptionContainer}>
              <div
                className={classes.projectElementDetail}
                style={{
                  borderBottom: "none",
                  minHeight: !_.isEmpty(elementPYP) ? 100 : "auto",
                }}
              >
                <ProjectElementTag
                  elementPYP={elementPYP}
                  onAddOrEditClick={projectElement =>
                    this.goToStep("TAG_PROJECT_ELEMENT", projectElement)
                  }
                />
              </div>
            </div>
            {parentType == "projects" && (
              <div className={classes.dateAndTimeContainer}>
                <DateSelector
                  label={`${t("common:evidence")} ${t(
                    "common:date_lowercase"
                  )}`}
                  name={"date"}
                  value={currentDate}
                  updateInputField={({ date }) => {
                    if (date) {
                      onDateAndTimeUpdate({
                        newDate: formatDate({ date, format: "YYYY-MM-DD" }),
                      });
                    }
                  }}
                  isValueMomentObj={false}
                  openDirection={"up"}
                />
                <TimeSelector
                  label={`${t("common:evidence")} ${t(
                    "common:time_lowercase"
                  )}`}
                  name={"time"}
                  value={currentTime}
                  updateInputField={({ time }) => {
                    if (time) {
                      onDateAndTimeUpdate({ newTime: `${time}:00` });
                    }
                  }}
                  SelectedTimeformat="HH:mm"
                  isValueMomentObj={false}
                  minuteStep={1}
                />
              </div>
            )}
          </div>
          {showMediaModal && (
            <MediaModal
              toggleMediaModal={this.toggleMediaModal}
              attachments={attachments}
            />
          )}
        </ScreenPanel>

        {showTagModal && (
          <CreatePost
            mode={mode}
            updatePost={updatePost}
            postDetails={postDetails}
            currentStep={tagModalType}
            onClickSave={onClickSave}
            onClickClose={this.onCloseTagModal}
            currentElementTag={currentElementTag}
            mediaCreationOptions={mediaCreationOptions}
            isDsComponent={
              PROJECT_TEMPLATE_FIELD_OBJECTS[currentElementTag]?.isDsComponent
            }
            isFullScreen={
              PROJECT_TEMPLATE_FIELD_OBJECTS[currentElementTag].isFullScreen
            }
          />
        )}
      </>
    );
  }
}

export default compose(I18nHOC({ resource: ["journal", "common"] }))(
  AddPostDetails
);
